module.exports = __webpack_public_path__ + "img/1.e940ef51.png";